<mat-menu>
  @if (tilgjengeligeMenyinnslag().velgDokumentInnhold) {
    <button mat-menu-item (click)="velgDokumentInnhold()">
      <mat-icon fontSet="ion-ios-settings" class="mat-icon&#45;&#45;ionic-ikon"/>
      {{ 'Velg dokumentinnhold'|translate }}
    </button>
  }
  @if (tilgjengeligeMenyinnslag().flytt) {
    <button mat-menu-item (click)="flytt()">
      <mat-icon>drive_file_move</mat-icon>
      {{ 'Flytt'|translate }}
    </button>
  }
  @if (tilgjengeligeMenyinnslag().nyVersjon) {
    <button mat-menu-item (click)="registrerNyVersjon()">
      <mat-icon>cloud_upload</mat-icon>
      {{ 'Registrer ny versjon'|translate }}
    </button>
  }
  @if (tilgjengeligeMenyinnslag().redigerSkjerming) {
    <button mat-menu-item (click)="visSkjerming()">
      <mat-icon>visibility_lock</mat-icon>
      {{ 'Vis tilganger'|translate }}
    </button>
    @if (redigeringMulig()) {
    <button mat-menu-item (click)="redigerSkjerming()">
      <mat-icon>visibility_lock</mat-icon>
      {{ 'Rediger tilgang'|translate }}
    </button>
    }
  }
  @if (tilgjengeligeMenyinnslag().skalSignere) {
    <button mat-menu-item
            (click)="signer()"
            matTooltip="{{'Du har blitt bedt om å signere dette dokumentet, klikk her for å starte signeringsprosessen'|translate}}"
            matTooltipPosition="right">
      <mat-icon svgIcon="sf:signer"/>
      {{ 'Signer'|translate }}
    </button>
  }
  @if (tilgjengeligeMenyinnslag().sendTilSignering) {
    <button mat-menu-item (click)="sendTilSignering()" [disabled]="!tilgjengeligeMenyinnslag().inlineVisning">
      <mat-icon svgIcon="sf:signer"/>
      @if (tilgjengeligeMenyinnslag().inlineVisning) {
        {{ 'Send til signering'|translate }}
      } @else {
        {{ 'Send til signering (krever PDF)'|translate }}
      }
    </button>
  }
  @if (tilgjengeligeMenyinnslag().visSignatarer) {
    <button mat-menu-item (click)="visSignatarer()">
      <mat-icon svgIcon="sf:signer"/>
      {{ 'Vis signeringsstatus'|translate }}
    </button>
  }
  @if (tilgjengeligeMenyinnslag().redigerSignatarer) {
    <button mat-menu-item (click)="redigerSignatarer()">
      <mat-icon svgIcon="sf:signer"/>
      {{ 'Rediger signatarer'|translate }}
    </button>
  }
  @if (tilgjengeligeMenyinnslag().avsluttSignering) {
    <button mat-menu-item (click)="avsluttSignering()">
      <mat-icon svgIcon="sf:signer"/>
      {{ 'Avslutt signering'|translate }}
    </button>
  }
  @if (tilgjengeligeMenyinnslag().favorittMarkering) {
    <button mat-menu-item (click)="endreFavorittmarkering()" class="favoritt" [class.er-favoritt]="erFavoritt()">
      <mat-icon>star</mat-icon>
      @if (erFavoritt()) {
        {{ 'Fjern fra favorittlisten'|translate }}
      } @else {
        {{ 'Legg til i favorittlisten'|translate }}
      }
    </button>
  }

  @if (redigeringMulig()) {
    <mat-divider/>
  }

  @if (tilgjengeligeMenyinnslag().slett) {
    <button mat-menu-item (klikk)="slett()" [bekreftKlikk]="'Ja, slett dokumentet' | translate">
      <mat-icon>delete</mat-icon>
      {{ 'Slett'|translate }}
    </button>
  }

  <mat-divider/>

  @if (tilgjengeligeMenyinnslag().visVersjoner) {
    <button mat-menu-item (click)="visAlleVersjoner()">
      <mat-icon fontSet="lederplan-ikon-versjoner" class="mat-icon--lederplan-ikon"/>
      {{ 'Vis alle {antall} versjonene'|translate : {antall: dokumentversjon().versjonsnummer} }}
    </button>
  }
 <!--
 gir lite relevante treff, utelates foreløpig
 @if (viserMenypunktVisLiknendeDokumenter()) {
    <button mat-menu-item (click)="visLiknendeDokumenter()">
      <mat-icon fontSet="ion-ios-list-outline" class="mat-icon&#45;&#45;ionic-ikon"/>
      {{ 'Vis liknende dokumenter'|translate }}
    </button>
  }-->
  @if (tilgjengeligeMenyinnslag().visBehandlesISaker) {
    <button mat-menu-item (click)="visSakerArkivdokumentBehandlesI()">
      <mat-icon>ballot</mat-icon>
      {{ 'Vis saker dokumentet behandles i'|translate }}
    </button>
  }
  @if (tilgjengeligeMenyinnslag().visIArkiv) {
    <button mat-menu-item (click)="gaaTilArkivinnslag()">
      <mat-icon fontSet="ion-ios-folder-outline" class="mat-icon--ionic-ikon"/>
      {{ 'Vis i bibliotek'|translate }}
    </button>
  }
  @if (tilgjengeligeMenyinnslag().visGaaTilProtokoll) {
    <button mat-menu-item (click)="gaaTilProtokoll()">
      <mat-icon fontSet="ion-ios-arrow-thin-right" class="mat-icon--ionic-ikon"/>
      {{ 'Gå til protokollen'|translate }}
    </button>
  }

  <div class="gruppe-tittel">{{'Last ned'|translate}}</div>

  @for (format of informasjon().formater; track format.mimeinfo.mimetype) {
    <a mat-menu-item [href]="format.url" download>
      <dokument-format-ikon [mimeinfo]="format.mimeinfo"/>
      {{ 'Som {format}'|translate : {format: format.mimeinfo.visningsnavn} }}
    </a>
  }

  @if (tilgjengeligeMenyinnslag().inlineVisning) {
    <button mat-menu-item (click)="aapneSom(informasjon().standardformat, false)">
      <dokument-format-ikon [mimeinfo]="informasjon().standardformat.mimeinfo"/>
      {{ 'Åpne i standard PDF-viser'|translate }}
    </button>
  }
  @if (tilgjengeligeMenyinnslag().aapneIGoogleDrive) {
    <button mat-menu-item (click)="aapneIGoogleDrive()">
      <mat-icon fontSet="lederplan-ikon-google-drive" class="mat-icon--lederplan-ikon"/>
      {{ 'Åpne original i Google Drive'|translate }}
    </button>
  }
  @if (tilgjengeligeMenyinnslag().aapneIMicrosoftOneDrive) {
    <button mat-menu-item (click)="aapneIMicrosoftOneDrive()">
      <mat-icon fontSet="lederplan-ikon-microsoft-onedrive" class="mat-icon--lederplan-ikon"/>
      {{ 'Åpne original i OneDrive'|translate }}
    </button>
  }
</mat-menu>


<!--dialog som vises dersom mappe ikke kan slettes -->
<ng-template #dokumentKanIkkeSlettesDialogTemplate>
  <div class="mappe-kan-ikke-slettes-dialog">
    <h2 mat-dialog-title>{{ "Biblioteksdokumentet '{filnavn}' kan ikke slette"|translate:{filnavn: informasjon().standardnavn} }}</h2>
    <mat-dialog-content>
      <p>{{ "Dokumentet er knyttet til saker og kan ikke slettes før det er fjernet fra sakene." | translate }}</p>
      <ul>
        @for (dokument of kanIkkeSlettesPgaBrukISaker(); track dokument.dokumentVersjon.id) {
          <li class="dokumenter">
            {{ dokument.dokumentVersjon.filnavn }}
            <span>{{ 'behandles i følgende saker:' | translate }}</span>
            <ul class="saker">
              @for (sak of dokument.tilknyttedeSaker; track sak.id) {
                <li>
                  <a (click)="gaaTilSak(sak)">
                    <span>
                      {{ "Sak {sakstittel} i {moetetittel} {moetedato}"|translate : {sakstittel: sak.tittel, moetetittel: sak.moete.tittel, moetedato: sak.moete.dato.start|zoneddatetimeSomPlaindate|plaindate} }}
                    </span>
                    <mat-icon inline="true">arrow_forward</mat-icon>
                  </a>
                </li>
              }
            </ul>
          </li>
        }
      </ul>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <button mat-button mat-dialog-close>{{ "Lukk"|translate }}</button>
    </mat-dialog-actions>
  </div>
</ng-template>
